
































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PpiBundleTrenChart from "@/components/ppi/rekap/PpiBundleTrenChart.vue";
import {
  PpiBundleTren,
  PpiRekapFase,
  PpiTrenMode
} from "@/services/PpiBundleRekapBulananService";

const WARNA = ["#0072B2", "#E69F00", "#009E73", "#CC79A7"];
const BENTUK_TITIK = ["circle", "triangle", "rect", "rectRot"];

@Component({
  components: { PpiBundleTrenChart }
})
export default class PpiBundleTrenCard extends Vue {
  @Prop({ default: null }) readonly tren!: PpiBundleTren | null;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ default: "bulanan" }) readonly granularitas!: PpiTrenMode;

  seri = "semua";

  granularitasItems = [
    { text: "Bulan", value: "bulanan" },
    { text: "Triwulan", value: "triwulan" },
    { text: "Semester", value: "semester" },
    { text: "Tahun (5 tahun terakhir)", value: "tahunan" }
  ];

  @Watch("tren")
  onTrenChange() {
    if (this.seri !== "semua" && !this.seriItems.some(i => i.value === this.seri)) {
      this.seri = "semua";
    }
  }

  get cakupanTeks(): string {
    if (!this.tren) return "";
    return this.tren.unit_id
      ? this.tren.unit_nama || this.tren.unit_id
      : `Cakupan ${this.tren.cakupan_label}`;
  }

  get seriItems(): Array<{ text: string; value: string }> {
    const items = [{ text: "Per bundle (VAP / ISK / IAD / IDO)", value: "semua" }];
    if (!this.tren) return items;
    return items.concat(
      this.tren.bundles.map(b => ({ text: `${b.label} per fase`, value: b.key }))
    );
  }

  get labels(): string[] {
    return this.tren ? this.tren.titik.map(t => t.singkat) : [];
  }

  get seriesTabel(): Array<{ key: string; label: string; titik: PpiRekapFase[] }> {
    const tren = this.tren;
    if (!tren) return [];

    if (this.seri === "semua") {
      return tren.bundles.map(b => ({
        key: b.key,
        label: b.label,
        titik: tren.titik.map(t => t.bundle[b.key])
      }));
    }

    return tren.phases
      .filter(p => p.bundle === this.seri)
      .map(p => ({
        key: p.key,
        label: `${p.bundle_label} ${p.fase_label}`,
        titik: tren.titik.map(t => t.fase[p.key])
      }));
  }

  get seriesChart() {
    return this.seriesTabel.map((s, i) => ({
      label: s.label,
      data: s.titik.map(agg => (agg && agg.den > 0 ? agg.capaian : null)),
      color: WARNA[i % WARNA.length],
      pointStyle: BENTUK_TITIK[i % BENTUK_TITIK.length]
    }));
  }

  get adaData(): boolean {
    const tren = this.tren;
    if (!tren) return false;
    return tren.phases.some(p => tren.titik.some(t => t.fase[p.key].den > 0));
  }

  get adaDibekukan(): boolean {
    return !!this.tren && this.tren.titik.some(t => t.dibekukan);
  }

  fmt(val: number | null): string {
    if (val === null || val === undefined) return "—";
    return val.toFixed(2).replace(".", ",");
  }

  kategoriClass(kategori: string): string {
    if (kategori === "baik") return "kat-baik";
    if (kategori === "intermediate") return "kat-intermediate";
    if (kategori === "minimal") return "kat-minimal";
    return "";
  }
}
